"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("cropperjs/dist/cropper.css");
var React = __importStar(require("react"));
var react_cropper_1 = __importDefault(require("react-cropper"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var Button_1 = __importDefault(require("../Button"));
var ContextBar_1 = require("../ContextBar");
var ScrollLayout_1 = __importDefault(require("../Layouts/ScrollLayout"));
var Loader_1 = require("../Loader");
var Modal_1 = __importDefault(require("../Modal"));
var TitlePanel_1 = __importDefault(require("../TitlePanel"));
var Settings_1 = __importDefault(require("./Settings"));
var utilities_1 = require("../utilities");
var Content = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n\n  ",
    "\n"])), function (_a) {
    var mask = _a.mask;
    return mask === 'ellipse' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .cropper-view-box {\n        border-radius: 50%;\n      }\n    "], ["\n      .cropper-view-box {\n        border-radius: 50%;\n      }\n    "])));
});
var StyledContentLoader = styled_components_1.default(Loader_1.ContentLoader)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left: 0;\n"])));
var PhotoEditor = /** @class */ (function (_super) {
    __extends(PhotoEditor, _super);
    function PhotoEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            initializing: true,
            settingsOpened: false,
            settings: {
                aspectRatio: _this.props.availableAspectRatios[0],
            },
        };
        _this.cropper = null;
        _this.handleSubmit = function () {
            var transformationData = _this.cropper.getData(true);
            _this.props.onSubmit(transformationData, new Promise(function (resolve) {
                _this.cropper.getCroppedCanvas().toBlob(function (blob) {
                    resolve(blob);
                });
            }));
        };
        _this.handleReady = function () {
            _this.setState({ initializing: false });
        };
        _this.handleOpenSettings = function () {
            _this.setState({ settingsOpened: true });
        };
        _this.handleCloseSettings = function () {
            _this.setState({ settingsOpened: false });
        };
        _this.handleSubmitSettings = function (settings) {
            _this.setState({ settings: settings, settingsOpened: false });
        };
        return _this;
    }
    PhotoEditor.prototype.render = function () {
        var _this = this;
        var _a = this.state, initializing = _a.initializing, settingsOpened = _a.settingsOpened, settings = _a.settings;
        var _b = this.props, onClose = _b.onClose, availableAspectRatios = _b.availableAspectRatios, viewMode = _b.viewMode, mask = _b.mask;
        var aspectRatio = (function (ratio) {
            if (ratio === null) {
                return null;
            }
            var _a = ratio.split(':'), x = _a[0], y = _a[1];
            if (x && y) {
                return Number(x) / Number(y);
            }
            return null;
        })(settings.aspectRatio);
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal_1.default, { isOpen: true, handleClose: onClose, size: "fullscreen" },
                React.createElement(ScrollLayout_1.default, { topFixed: React.createElement(TitlePanel_1.default, { title: "Obr\u00E1zkov\u00FD editor" }), bottomFixed: React.createElement(ContextBar_1.ContextBar, null,
                        React.createElement(ContextBar_1.ContextBarItem, null,
                            React.createElement(Button_1.default, { onClick: onClose }, utilities_1.__('Zahodiť'))),
                        availableAspectRatios.length > 1 && (React.createElement(ContextBar_1.ContextBarItem, null,
                            React.createElement(Button_1.default, { onClick: this.handleOpenSettings }, utilities_1.__('Nastavenia')))),
                        React.createElement(ContextBar_1.ContextBarSpacer, null),
                        React.createElement(ContextBar_1.ContextBarItem, null,
                            React.createElement(Button_1.default, { primary: true, onClick: this.handleSubmit }, "Hotovo"))) },
                    React.createElement(Content, { mask: mask },
                        initializing && React.createElement(StyledContentLoader, { size: "xl" }),
                        React.createElement(react_cropper_1.default, { ready: this.handleReady, style: { height: '100%', width: '100%' }, aspectRatio: aspectRatio, guides: true, center: false, autoCropArea: 0.5, data: this.props.data, viewMode: viewMode, dragMode: "move", src: this.props.src, ref: function (cropper) {
                                _this.cropper = cropper;
                            } })))),
            React.createElement(Settings_1.default, { isOpen: settingsOpened, onClose: this.handleCloseSettings, onSubmit: this.handleSubmitSettings, availableAspectRatios: availableAspectRatios || [], settings: settings })));
    };
    PhotoEditor.defaultProps = {
        data: undefined,
        availableAspectRatios: ['4:3', '16:9', '1:1', null],
        viewMode: 0,
        mask: undefined,
    };
    return PhotoEditor;
}(React.PureComponent));
exports.default = PhotoEditor;
var templateObject_1, templateObject_2, templateObject_3;
